// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2FGrT","tab":"ProcedureTabs_tab__1h435"};